import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import classNames from 'classnames/bind';
import { Button, Cell } from '@carnica/ui-kit';
import { connect } from 'react-redux';
import { selectFubGroupsCount, selectFubGroupsError, selectFubGroupsLoading, selectFubMembers, selectFubMembersCount, selectFubStatus } from "../../store/selectors";
import { renderRightSide } from "../../utils/helper";
import { getGroupTitleBlock, getIsStatusEnabled } from "../../utils";
import styles from "./styles.pcss";
import { selectBaseUrl, selectUserType } from "../../../../../store/selectors";
import { ANALYTICS_ACTION, ANALYTICS_ITEM_TYPE } from "../../constants/analytics";
import { FUB_COMMON_STATUS, fubTexts } from "../../constants";
import { pushFubAnalytics } from "../../utils/analytics";
import { Skeleton } from "../../../common/Skeleton";
var cn = classNames.bind(styles);
var _GroupBanner = function _GroupBanner(_ref) {
  var fubMembersCount = _ref.fubMembersCount,
    fubGroupsCount = _ref.fubGroupsCount,
    fubStatus = _ref.fubStatus,
    members = _ref.members,
    isLoading = _ref.isLoading,
    target = _ref.target,
    userType = _ref.userType,
    isError = _ref.isError,
    baseUrl = _ref.baseUrl;
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Cell, {
      className: cn('cell'),
      leftSide: function leftSide() {
        return /*#__PURE__*/React.createElement(Skeleton, {
          className: cn('short')
        });
      },
      "data-t-id": "components-GroupBanner"
    });
  }
  if (!getIsStatusEnabled(fubStatus) && !isError) {
    return null;
  }
  var titleBlock = isError ? {
    title: fubTexts.membersBannerTitle.error
  } : getGroupTitleBlock(fubStatus, fubMembersCount, fubGroupsCount);
  var handleBannerClick = function handleBannerClick() {
    var commonParams = {
      account_type: userType,
      action: ANALYTICS_ACTION.CLICK,
      item_type: ANALYTICS_ITEM_TYPE.BANNER,
      banner_name: 'fub_group',
      banner_text: titleBlock === null || titleBlock === void 0 ? void 0 : titleBlock.title,
      user_status: fubStatus
    };
    var params = fubStatus === FUB_COMMON_STATUS.MASTER ? _objectSpread(_objectSpread({}, commonParams), {}, {
      account_count: fubMembersCount
    }) : _objectSpread({}, commonParams);
    pushFubAnalytics(target, _objectSpread({}, params));
    window.location.href = "".concat(baseUrl, "?openGroupsModal");
  };
  return /*#__PURE__*/React.createElement(Button, {
    className: cn('wrap'),
    mode: "inline",
    onClick: handleBannerClick,
    view: "secondary"
  }, /*#__PURE__*/React.createElement(Cell, _extends({
    className: cn('cell'),
    rightSide: function rightSide() {
      return renderRightSide(fubStatus, members, isError);
    }
  }, titleBlock, {
    "data-t-id": "components-GroupBanner"
  })));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    fubGroupsCount: selectFubGroupsCount(state),
    fubMembersCount: selectFubMembersCount(state),
    fubStatus: selectFubStatus(state),
    members: selectFubMembers(state),
    isLoading: selectFubGroupsLoading(state),
    userType: selectUserType(state),
    isError: selectFubGroupsError(state),
    baseUrl: selectBaseUrl(state)
  };
};
var mapDispatchToProps = {};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var GroupBanner = connector(_GroupBanner);